// src/pages/DashboardPage.js
// Updated: 10/31/2025 06:22 PM EDT
// --- THIS IS THE FULL, UPDATED FILE ---

import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext'; // Import our hook
import { db } from '../firebaseConfig';
import { doc, getDoc } from 'firebase/firestore';
import ActiveMotionsWidget from '../components/dashboard/ActiveMotionsWidget';
import ActiveScoringWidget from '../components/dashboard/ActiveScoringWidget';

export default function DashboardPage() {
  const { currentUser, userData } = useAuth(); // Get data from our context
  const [orgName, setOrgName] = useState('Loading...');

  // Effect to fetch the organization's name
  useEffect(() => {
    // Check if we have user data and an orgId
    if (userData && userData.orgId) {
      const fetchOrgName = async () => {
        try {
          const orgDocRef = doc(db, 'organizations', userData.orgId);
          const orgDocSnap = await getDoc(orgDocRef);
          if (orgDocSnap.exists()) {
            setOrgName(orgDocSnap.data().name); // Set the org name from Firestore
          } else {
            setOrgName('Organization Not Found');
          }
        } catch (err) {
          console.error('Error fetching organization:', err);
          setOrgName('Error loading org');
        }
      };
      
      fetchOrgName();
    }
  }, [userData]); // Re-run this effect if userData changes

  return (
    // The white background, shadow, etc., are now part of this page
    <div className="space-y-6">
      <div className="rounded-lg bg-white p-6 shadow-lg">
        <div className="border-b border-gray-200 pb-4">
          <h1 className="text-3xl font-bold text-gray-900">
            {orgName} Dashboard
          </h1>
          <p className="mt-2 text-lg text-gray-600">
            Welcome back, {currentUser?.displayName || 'User'}!
          </p>
        </div>

        <div className="mt-6">
          <h2 className="text-xl font-semibold text-gray-800">
            Your Information
          </h2>
          <ul className="mt-4 space-y-2 text-gray-700">
            <li>
              <span className="font-medium">Email:</span> {currentUser?.email}
            </li>
            <li>
              <span className="font-medium">Your Role:</span> {userData?.role}
              {userData?.super_admin && (
                <span className="ml-2 rounded-full bg-purple-100 px-2 py-0.5 text-xs font-semibold text-purple-700">
                  SUPER ADMIN
                </span>
              )}
            </li>
          </ul>
        </div>
      </div>

      {/* --- QUICK ACTIONS SECTION --- */}
      <div>
        <h2 className="mb-4 text-2xl font-semibold text-gray-800">
          Quick Actions
        </h2>
        
        {/* Grid for widgets */}
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
          {/* Active Motions Widget */}
          <ActiveMotionsWidget />

          {/* Active Scoring Widget */}
          <ActiveScoringWidget />
        </div>
      </div>
    </div>
  );
}